import React, { useState } from 'react';
import {
  ChamberMemberOverviewFilterModel,
  initialChamberMemberOverviewFilterModel,
} from 'app/edozvola/chamber-member-overview/model/chamber-member-overview.model';
import { useFormik } from 'formik';
import { paginationKeys } from 'app/shared/util/pagination.constants';
import { Col, Collapse, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button, Label } from 'edozvola-frontend-lib/dist/ui';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown';
import { isEqual } from 'lodash';
import { Input } from 'edozvola-frontend-lib/dist/ui/components';
import { fetchChamberMembersForChamberQuery, fetchChamberMembersQuery, fetchChambersQuery } from 'app/edozvola/codebooks/codebooks.queries';
import {
  chamberMemberOverviewFilterSchema
} from 'app/edozvola/chamber-member-overview/model/chamber-member-overview.schema';

export interface ChamberMemberOverviewFilterProps {
  filterForm: ChamberMemberOverviewFilterModel;
  setFilterForm: any;
  modal: any;
  closeModal: any;
}

export const ChamberMemberFilterModal = (props: ChamberMemberOverviewFilterProps) => {
  const [chamberMemberSectionShown, setChamberMemberSectionShown] = useState<boolean>(true);

  const formik = useFormik({
    initialValues: props.filterForm,
    onSubmit: values => {
      props.setFilterForm(values);
      localStorage.setItem(`${paginationKeys.CHAMBER_MEMBER_OVERVIEW}-filter-form`, JSON.stringify(values));
      props.closeModal();
    },
    enableReinitialize: true,
    validationSchema: chamberMemberOverviewFilterSchema,
    validateOnChange: true,
    validateOnMount: true
  });

  const { data: chamberOptions} = fetchChambersQuery();
  const { data: chamberMemberOptions } = formik.values?.chamber[0]?.id ? fetchChamberMembersForChamberQuery(formik.values.chamber[0].id) : fetchChamberMembersQuery();

  const closeModal = () => {
    formik.setValues(props.filterForm);
    props.closeModal();
  };

  const clearFilter = () => {
    formik.resetForm({ values: initialChamberMemberOverviewFilterModel });
  };

  return (
    <Modal scrollable size={'xl'} backdrop="static" isOpen={!!props.modal} toggle={() => closeModal()} centered={true}>
      <ModalHeader close={<FontAwesomeIcon className={'hand'} icon={faXmark} />} onClick={e => closeModal()} className={'d-flex'}>
        Pretraga projektanata
      </ModalHeader>
      <ModalBody className={'modal-body-dropdown-on-top'}>
        <Row className={'hand'} onClick={() => setChamberMemberSectionShown(prevState => !prevState)}>
          <Col xs={6}>
            <div className={'form-header'}>Projektant</div>
          </Col>
          <Col xs={6} className={'d-flex justify-content-end'}>
            <FontAwesomeIcon size="lg" color="outline" icon={chamberMemberSectionShown ? 'chevron-circle-up' : 'chevron-circle-down'} />
          </Col>
        </Row>
        <Collapse isOpen={chamberMemberSectionShown}>
          <Row>
            <Col xs={6}>
              <FormGroup>
                <Label labelText={'Komora'} />
                <PaginatedDropdown
                  onItemSelect={option => {
                    formik.setFieldValue('chamberMember', []);
                    formik.setFieldValue('chamber', option);
                  }}
                  selected={formik.values.chamber ?? []}
                  labelKey={'value'}
                  options={chamberOptions ?? []}
                  positionFixed
                  clearButton
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <FormGroup>
                <Label labelText={'Broj ovlaštenja/Ime i prezime'} />
                <PaginatedDropdown
                  onItemSelect={option => {
                    formik.setFieldValue('oib', '');
                    formik.setFieldValue('firstName', '');
                    formik.setFieldValue('lastName', '');
                    formik.setFieldValue('chamberMember', option);
                  }}
                  selected={formik.values.chamberMember}
                  labelKey={'value'}
                  options={chamberMemberOptions ?? []}
                  positionFixed
                  clearButton
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <FormGroup>
                <Label labelText={'OIB'} />
                <Input
                  value={formik.values.oib}
                  disabled={
                    formik.values.chamberMember?.length > 0 || formik.values.firstName?.length > 0 || formik.values.lastName?.length > 0
                  }
                  maxLength={11}
                  onChange={e => formik.setFieldValue('oib', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <FormGroup>
                <Label labelText={'Ime'} />
                <Input
                  value={formik.values.firstName}
                  disabled={formik.values.chamberMember?.length > 0 || formik.values.oib?.length > 0}
                  onChange={e => formik.setFieldValue('firstName', e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <FormGroup>
                <Label labelText={'Prezime'} />
                <Input
                  value={formik.values.lastName}
                  disabled={formik.values.chamberMember?.length > 0 || formik.values.oib?.length > 0}
                  onChange={e => formik.setFieldValue('lastName', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        </Collapse>
        <ModalFooter>
          <div>
            <Button
              color={'secondary'}
              size={'lg'}
              label={'Poništi'}
              prependIcon={'repeat'}
              onClick={clearFilter}
              disabled={isEqual(formik.values, initialChamberMemberOverviewFilterModel)}
            />
          </div>
          <div className={'float-end'}>
            <Button
              color={'info'}
              size={'lg'}
              label={'Pretraži'}
              prependIcon={'search'}
              onClick={formik.submitForm}
              disabled={!formik.isValid || isEqual(formik.values, props.filterForm)}
            />
          </div>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}
